export const checkFormValidity = (checkoutForms: HTMLInputElement[]) => {
  try {
    let checkoutFormValidity = true;

    for (const form of checkoutForms) {
      if (form) {
        let isVisible = true;
        if (
          window.getComputedStyle(form).display === 'none' ||
          window.getComputedStyle(form).visibility === 'hidden'
        ) {
          isVisible = false;
        }

        if (isVisible) {
          const isFormValid = form.reportValidity();
          if (!isFormValid) {
            checkoutFormValidity = false;
            break;
          }
        }
      }
    }

    return { checkoutFormValidity };
  } catch (error) {
    throw error;
  }
};
